import { Truck, Phone, Mail, MessageCircle, Instagram } from "lucide-react";
import { CONTACTS, EMAIL, WHATSAPP_URL, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#040405] pt-16 pb-10 overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 divider-glow" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="flex h-10 w-10 items-center justify-center bg-gradient-to-br from-[#0055ff] to-[#001a4d] border border-blue-400/30 shadow-[0_0_15px_rgba(0,85,255,0.4)]">
                <Truck className="h-5 w-5 text-white" strokeWidth={2.4} />
              </div>
              <div className="leading-tight">
                <div className="font-heading text-base font-black tracking-[0.18em] uppercase text-white">
                  Bennici
                </div>
                <div className="font-heading text-[10px] tracking-[0.32em] uppercase text-blue-300/80">
                  Autotrasporti · Canicattì
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed max-w-sm">
              Autotrasporti Bennici Canicattì — Trasporti e Logistica con
              affidabilità, puntualità e sicurezza in tutta Italia.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-blue-300/80 mb-5">
              Naviga
            </div>
            <ul className="space-y-3 text-sm text-gray-400">
              <li>
                <a
                  href="#chi-siamo"
                  className="hover:text-blue-300 transition-colors"
                >
                  Chi Siamo
                </a>
              </li>
              <li>
                <a
                  href="#servizi"
                  className="hover:text-blue-300 transition-colors"
                >
                  Servizi
                </a>
              </li>
              <li>
                <a
                  href="#vantaggi"
                  className="hover:text-blue-300 transition-colors"
                >
                  Vantaggi
                </a>
              </li>
              <li>
                <a
                  href="#contatti"
                  className="hover:text-blue-300 transition-colors"
                >
                  Contatti
                </a>
              </li>
            </ul>
          </div>

          {/* Contacts */}
          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-blue-300/80 mb-5">
              Contatti rapidi
            </div>
            <ul className="space-y-3 text-sm text-gray-400">
              {CONTACTS.map((c) => (
                <li key={c.tel} className="flex items-center gap-2">
                  <Phone size={14} className="text-blue-400" />
                  <a
                    href={`tel:${c.tel}`}
                    className="hover:text-white transition-colors"
                  >
                    {c.name} — {c.phone}
                  </a>
                </li>
              ))}
              <li className="flex items-center gap-2 break-all">
                <Mail size={14} className="text-blue-400 flex-shrink-0" />
                <a
                  href={`mailto:${EMAIL}`}
                  className="hover:text-white transition-colors"
                >
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle size={14} className="text-green-400" />
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  WhatsApp diretto
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram size={14} className="text-pink-400" />
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="hover:text-white transition-colors"
                >
                  {INSTAGRAM_HANDLE}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs uppercase tracking-[0.22em] text-gray-600">
            © {new Date().getFullYear()} Autotrasporti Bennici Canicattì · Tutti
            i diritti riservati
          </div>
          <div className="text-[10px] uppercase tracking-[0.32em] text-blue-400/60">
            Canicattì · Sicilia · Italia
          </div>
        </div>
      </div>
    </footer>
  );
}
